import Vue from 'vue'
import Router from 'vue-router'
import store from '../store';

// Routes
import paths from './paths'

function route(path, view, name, meta) {
  return {
    name: name || view,
    path,
    meta: meta || {},
    component: (resolve) => import(
      `@/views/${view}.vue`
    ).then(resolve)
  }
}

Vue.use(Router)

// Create a new router
const router = new Router({
  mode: 'history',
  routes: paths.map(path => route(path.path, path.view, path.name, path.meta)).concat([
    { path: '*', redirect: '/' }
  ]),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  let token = store.getters["auth/token"];

  //primeiro verifica se a página que está tentando acessar, precisa de autenticação
  if (to.matched.some(record => record.meta.requiresAuth)) {

    //verifica se existe token de autenticação válido
    if (token) {

      //recebe todas as claims de acesso
      let claims = store.getters["auth/claims"];

      //verifica se a tela que está tentando acessar exige restrição de acesso
      if (to.meta.id && to.meta.idRestricao) {

        //se existir restrição, verifica se usuário possui acesso a tela
        if (claims.some(c => c.idTela === to.meta.id && c.idRestricao === to.meta.idRestricao)) {

          //se existir, acessa a tela.
          next()
          return
        } else {          

          //se não existir volta para a tela anterior
          next(from.path);
          return
        }
      }

      //se a tela não exigir restrição, vai para a próxima tela
      next()
      return;
    }

    //se token não for válido, encaminhar para a tela de login
    next('/login')
  } else {

    //caso a tela não exigit autenticação, verifica se a tela que está tentando acessar é a tela de login, caso for e o usuário já estiver autenticado, encaminhar para a home
    if (to.name === 'Login' && token) next('/')
    else next() //se não, deixar seguir na tela que está tentando acessar
  }
})

export default router